import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "reactstrap";
import {
  getEvent,
} from "../../redux/actions/indexActions";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { MdAdd } from "react-icons/md";
import { Input } from "reactstrap";
import Pagination from "../../Components/Paginate";
import moment from "moment/moment";

const EventIndex = () => {
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
    indexReducer: {
      EventLists,
      eventCount,
    },
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const [paginate, setPaginate] = useState(10);
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;
  useEffect(() => {
    dispatch(getEvent(auth?.token, paginate, page, search, sort))
  }, [auth, paginate, page, search, sort]);


  const handleDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete This Event")) {
      axios
        .delete(`/api/admin/v1/event-delete/${id}`, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        })
        .then((res) => {
          toast.success(res.data.message);
          dispatch(getEvent(auth?.token));
        })
        .catch((err) => toast.error("Somthing Went Wrong"));
    }
  };
  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="mb-4 d-flex align-items-center justify-content-between" >
            <h5 className="mb-0 text-white fs-4">Event List</h5>
            {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "EVENTS" && item?.permission?.permission === "create") && (
              <Link to="/add-event">
                <Button className="bg-white text-black" size="sm">
                  <span className="me-2">
                    <MdAdd size={22} />
                  </span>
                  Add Event
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4" style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}>

        <div className="row">
          <div className="col-md-3 mb-2">
            <Input size={"sm"} value={search} placeholder='Search By Name' onChange={(({ target: { value } }) => setSearch(value))} />
          </div>
          <div className="col-md-2 offset-md-7">
            <Input type="select" size={"sm"} value={sort} onChange={(({ target }) => setSort(target.value))} >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Input>
          </div>
          <div className="col-md-12">
            <Table hover responsive>
              <thead>
                <tr>
                  <th>SL. No.</th>
                  <th>Name</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Thumbnail</th>
                  <th>Contact Person</th>
                  <th>Description</th>
                  {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "EVENTS" && (item?.permission?.permission === "edit" || item?.permission?.permission === "delete")) && (
                    <th>Action</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {EventLists.length === 0 ? (
                  <tr>
                    <td colSpan="6">No data found</td>
                  </tr>
                ) : (<>
                  {EventLists?.map?.((item, index) => {
                    return (
                      <tr key={item.id}>
                        <th scope="row">{index + 1 + page * paginate}</th>
                        <td>{item?.event_name} <br /> {item?.location}</td>
                        <td>{moment(item?.start_date).format("DD-MM-yyyy hh:mm A")}</td>
                        <td>{moment(item?.end_date).format("DD-MM-yyyy hh:mm A")}</td>
                        <td>
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + `/${item?.thumbnail}`}
                            height={45}
                            width={45}
                          />
                        </td>
                        <td>{item?.contact_person} <br />{item?.email}
                          <br />{item?.mobile}</td>
                        <td dangerouslySetInnerHTML={{
                          __html: item?.description?.slice(0, 50),
                        }}></td>
                        <td>
                          <div className="d-flex align-items-center">
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "EVENTS" &&
                                item?.permission?.permission === "edit"
                            ) && (
                                <Link to={`/edit-event/${item?.id}`}>
                                  <AiOutlineEdit
                                    size={22}
                                    className="text-warning me-3"
                                  />
                                </Link>
                              )}
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "EVENTS" &&
                                item?.permission?.permission === "delete"
                            ) && (
                                <AiOutlineDelete
                                  size={22}
                                  className="text-danger"
                                  onClick={() => handleDel(item.id)}
                                />
                              )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}</>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-md-6 d-flex">
            <div className="col-md-2">
              <Input
                type="select"
                id="paginate"
                onChange={e =>
                  setPaginate(
                    e.target.value
                  )
                }
                value={paginate}
                className="paging custom-select custom-select-page m-0"
              >
                <option value="10">
                  10
                </option>
                <option value="20">
                  20
                </option>
                <option value="50">
                  50
                </option>
                <option value="100">
                  100
                </option>
                <option value="200">
                  200
                </option>
                <option value="500">
                  500
                </option>
              </Input>
            </div>
            <div className='col-md-10 text-black d-flex align-items-center ps-3'>
              {eventCount > 0 ? (
                <>
                  Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, eventCount)} of {eventCount} entries
                </>
              ) : (
                <>
                  Showing 0 to 0 of 0 entries
                </>
              )}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='d-flex justify-content-end'>
              <Pagination
                pageCount={(eventCount) / paginate}
                onChange={(e) => setPage(e.selected)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventIndex;
